import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const languages = {
    "pt-BR": {
        views: {
            statementGame:{
                titles: ["Política de privacidade", "Termos de uso", "DA ACEITAÇÃO", "DO OBJETIVO", "DA PLATAFORMA", "DOS HORÁRIOS DAS SESSÕES E AGENDAMENTOS", "SENHAS E SEGURANÇA:", "DAS RESPONSABILIDADES", "DA PRIVACIDADE E DO USO DE INFORMAÇÕES DO USUÁRIO", "DIREITO DE PROPRIEDADE", "DISPOSIÇÕES GERAIS", "DO FORO:", ],
                paragraphs: [
                    "Todas as suas informações pessoais recolhidas serão usadas para tornar seu acesso à nossa plataforma mais produtivo e agradável.", 
                    "A garantia da confidencialidade dos dados pessoais dos utilizadores da nossa plataforma é importante para a Huddle, por isso, todas as informações pessoais serão tratadas em concordância com a Lei Geral de Proteção de Dados Pessoais de 14 de agosto de 2018 (Lei n.º 13.709/2018).", 
                    "As informações pessoais recolhidas podem incluir o seu nome, e-mail, número de telefone e CPF.", 
                    "Lembrando que o uso da plataforma pressupõe a aceitação deste acordo de privacidade.", 
                    "A equipe da Huddle reserva-se o direito de alterar este acordo sem aviso prévio. Deste modo, recomendamos que consulte a nossa política de privacidade com regularidade de forma a estar sempre atualizado.", 
                    "O presente termo de aceitação de uso (“Termo”) da nossa plataforma (“Plataforma”) é celebrado entre a HUDDLE TECNOLOGIA EM RH LTDA. (“Huddle”), inscrita no CNPJ/MF sob o número 19.653.495/0001-86, mantenedora e única titular do Repense Game, Cripto Game e Decode Game (“Games”), e o candidato(a) (“Pessoa”), que, adere integralmente ao Termo clicando abaixo em “Cadastrar-se” ou na caixa de aceitação do Termo.", 
                    "A Pessoa somente poderá utilizar a Plataforma, caso concorde integralmente em cumprir com todos os termos e condições abaixo estabelecidos, sendo que a anuência ao presente Termo poderá se dar das seguintes maneiras:", 
                    "Clicando na caixa de aceitação do Termo;", 
                    "Realizando o cadastramento de dados pessoais, que será considerado como aceitação incondicional dos termos e condições ora propostos.", 
                    "A PESSOA poderá esclarecer dúvidas sobre o presente Termo entrando em contato diretamente com a Huddle, por meio da nossa página no facebook", 
                    "ou por e-mail", 
                    "Ao concordar com o presente Termo, a Pessoa passa a ter o direito de utilizar seu acesso à Plataforma para realizar seu cadastro, agendamentos, participar dos games dos processos seletivos, consultar as regras e esclarecer dúvidas.", 
                    "As regras que serão observadas estão dispostas em “Regras do Jogo” e também disponibilizadas", 
                    "neste link", 
                    "A Huddle compromete-se a manter os dados cadastrais e de acesso do Pessoa confidenciais nos termos da lei, ressaltando que compartilhará as informações de resultado dos games com a consultoria de recursos humanos (“Consultoria”) e/ou com a empresa (“Empresa”) responsáveis/responsável pelo processo seletivo.", 
                    "A Huddle prestará suporte técnico a Pessoa para utilização plena da Plataforma, nos horários e formas padronizadas pela própria Huddle e durante as sessões dos games segundo as regras divulgadas no site.", 
                    "A Pessoa, por seu lado, reconhece que a área de tecnologia da informação está sempre em constante desenvolvimento, e que a perfeição e ausência de defeitos ou riscos são inexistentes nesse setor.", 
                    "É de exclusiva responsabilidade e ônus da Pessoa providenciar os equipamentos de informática e a conexão à Internet necessários para o acesso à Plataforma. A Huddle não se responsabiliza, em nenhuma hipótese, pela existência, funcionamento e qualidade de tais equipamentos, sistemas e conexões.", 
                    "A Pessoa compreende e concorda que a Huddle poderá suspender ou interromper o funcionamento da Plataforma para fins de manutenção, ou por caso fortuito, ou de força maior, independentemente de qualquer aviso prévio.", 
                    "A Plataforma pode conter alguns modelos de Games, que avaliam as competências da Pessoa, podendo ser compostos por mais de 1 etapa de jogo. O objetivo central dos referidos Games é resolver os as situações problemáticas propostas. Em alguns casos, para participar será necessário realizar o agendamento em uma sessão, de acordo com as datas e horários disponíveis.", 
                    "A quantidade de sessões, bem como as datas e horários, serão determinados pela Consultoria ou pela Empresa responsável pelo processo seletivo.", 
                    "Eventualmente, a Huddle poderá definir a quantidade de sessões, bem como as datas e os horários em que estas correrão, com base no levantamento das maiores quantidades de acesso, extraídos do histórico de partidas já realizadas.", 
                    "É possível realizar o reagendamento de acordo com as sessões disponíveis, exceto em casos de última sessão. Desta forma, recomendamos que realize o game o quanto antes, para evitar eventuais problemas.", 
                    "Em nenhuma hipótese será possível realizar o game sem o agendamento prévio.", 
                    "A Pessoa reconhece que sua senha de acesso ao site é de uso pessoal e intransferível, bem como sua performance, não podendo, em nenhuma hipótese, fornecê-la a terceiros, ou ter o game jogado por outra pessoa e, consequentemente, ter sua performance obtida por outra pessoa, devendo tomar todas as providências cabíveis para garantir sua confidencialidade.",
                    "a Pessoa compromete-se a responder integralmente por quaisquer consequências jurídicas decorrentes diretamente da perda ou extravio de sua senha, devido a um comportamento seu considerado doloso ou culposo (imprudência, negligência imperícia).", 
                    "A Plataforma é oferecida a Pessoa, e é por este aceito, no estado técnico e de perfeição em que se encontra, razão pela qual a Huddle não responde por nenhuma outra garantia; não se responsabilizando, entre outras, as seguintes hipóteses:", 
                    "pela adequação do site às necessidades ou expectativas da Pessoa;", 
                    "pelos resultados ou desempenhos esperados pela Pessoa ao usar a Plataforma;", 
                    "por qualquer informação, convocação ou comunicação veiculada pela Empresas e/ou Consultoria do processo seletivo;", 
                    "A validade do e-mail de convocação está descrita no corpo do e-mail. Em casos em que não estiver, o prazo limite de agendamento é de até 10 minutos antes da última sessão disponível.", 
                    "por problemas com conexão, energia elétrica, falha técnica de componentes e afins que não estão no nosso controle; e", 
                    "por problemas durante a realização do game, ainda que originados pela Huddle, não relatados no momento que ocorreu ou em até duas horas após o fim da sessão.", 
                    "A Huddle é responsável apenas pelo game, e não possui influência sobre o cronograma do processo seletivo, convocações para outras etapas, informações de aprovados, envios de reprovação as Pessoa, entre outros, que são de responsabilidade da Consultoria e/ou Empresa do processo seletivo.", 
                    "Ambas as partes declaram ter pleno conhecimento de que o uso de qualquer sistema de informática em ambiente exposto à internet está sujeito a ataques de terceiros, não se responsabilizando nenhuma das partes perante a parte contrária, ou terceiros, por quaisquer danos causados por invasões no site por hackers, ou terceiros com intenções semelhantes.", 
                    "A Huddle reserva-se o direito de, uma vez constatado descumprimento pela Pessoa de qualquer obrigação decorrente do presente Termo, ou ainda que seja constatado indícios de fraude na performance da Pessoa, excluir seu cadastro e notificar a Empresa e/ou Consultoria do processo seletivo, sem prejuízo da possibilidade de remessa de seus dados cadastrais e de acesso às autoridades legais competentes, sem que isso represente lesão a seus direitos de privacidade.", 
                    "A Pessoa se compromete a não compartilhar qualquer informação do game com terceiros, incluindo printscreen, redações de enigmas, respostas, ou qualquer informação que seja entendida como confidencial pelo time de Auditoria de Performance da Huddle.", 
                    "O chat, na etapa do Team Game, é de uso obrigatório, não sendo autorizado o uso de outros meios de comunicação para a resolução dos enigmas em grupo. A não observação dessa cláusula impacta diretamente na performance e pode ocasionar a eliminação da participação da Pessoa no processo seletivo.", 
                    "A Pessoa se compromete a informar ao suporte técnico da Huddle sobre qualquer indício de fraude que presencie, ou tome conhecimento, a fim de garantir a lisura do processo seletivo.", 
                    "A Huddle reserva-se o direito de eliminar a Pessoa que não cumprir qualquer um dos aspectos tratados neste Termo.", 
                    "É política da Huddle respeitar a privacidade das Pessoas. Assim sendo, a Huddle não editará ou revelará nenhuma informação da Pessoa ou sobre o uso destes serviços pela Pessoa, sem sua permissão, excetuando para o fim deste Termo e nas hipóteses de tal conduta ser necessária para:", 
                    "proteger o interesse da Huddle ou de terceiros;", 
                    "responder a eventual reclamação de que tal conteúdo viole direitos de terceiros;", 
                    "identificar e resolver problemas técnicos;", 
                    "cumprir procedimento legal, inclusive determinação judicial ou de qualquer órgão regulatório competente;", 
                    "fazer cumprir os termos dos serviços ora prestados.", 
                    "Coletamos informações anônimas de navegação dos usuários através de sistemas de terceiros autorizados, respeitadas todas as questões de segurança e privacidade de dados, com o objetivo de compreender melhor o perfil de nossa audiência ou oferecer uma melhor experiência de navegação. Caso não queira que dados anônimos de navegação sejam utilizados, acesse e altere as configurações de privacidade do seu browser.", 
                    "Privacidade do celular: Ao cadastrar o número do seu telefone celular estará autorizando a Huddle a enviar lembretes dos agendamentos e demais necessidades de contato que possam ser mapeadas ao longo do processo.", 
                    "A Pessoa tem ciência de que, com sua anuência, a partir do seu cadastro e aceitação do Termo, poderão ser enviadas mensagens para seu e-mail sobre o agendamento e/ou reagendamento do horário da sessão.", 
                    "A Pessoa reconhece que todo o conteúdo (escrito, falado, imagem e som) exibido na plataforma da Huddle está protegido pela lei que regulamenta marcas, patentes e demais direitos de propriedade industrial.", 
                    "A Pessoa compromete-se a não utilizar tal conteúdo sem prévio e expresso conhecimento da Huddle, sob pena de ser responsabilizado civil e criminalmente pelas violações que cometer aos direitos alheios.", 
                    "A Huddle se reserva o direito de alterar a qualquer tempo os termos e condições deste Termo, que será sempre exibido as Pessoas que acessarem este documento através do site.", 
                    "As partes elegem o Foro da Comarca da Capital do Estado de São Paulo como competente para dirimir eventuais conflitos originários do presente contrato", 
                    "Li e compreendo", 
                    "os termos acima"
                ],
                seeMoreLink: "ver tudo",
                textButton: "próximo"
            },
            rules: {
                "title-rules": {
                    title: "Relembrando algumas",
                    regras: "regras"
                },
                "text-rules": {
                    p: "IMPORTANTE",
                    strong1: "Não estamos testando conhecimentos.",
                    span1: "Por isso, você poderá ",
                    strong2: "pesquisar à vontade ",
                    span2: "para encontrar as respostas.",
                    li1: {
                        span1: "Você começará com ",
                        strong1: "40.000 pontos",
                        span2: ", que serão usados para ",
                        strong2: "investir em enigmas ",
                        span3: "e para ",
                        strong3: "comprar pistas;"
                    },
                    li2: {
                        span1: "O ",
                        strong1: "prêmio ",
                        span2: "será sempre o ",
                        strong2: "dobro de pontos ",
                        span3: "que você usou para ",
                        strong3: "investir no enigma;"
                    },
                    li3: {
                        span1: "Cada ",
                        strong1: "pista ",
                        span2: "comprada custará ",
                        strong2: "500 pontos;"
                    },
                    li4: {
                        span1: "Você tem ",
                        strong1: "3 tentativas disponíveis",
                        span2: "e depois pagará ",
                        strong2: "50 pontos por tentativa;"
                    },
                    li5: {
                        span1: "Você terá ",
                        strong1: "10 minutos ",
                        span2: "para concluir ",
                        strong2: "cada enigma;"
                    },
                    li6: {
                        span1: "Após ",
                        strong1: "5 minutos ",
                        span2: "você ",
                        strong2: "perderá 1 ponto por segundo decorrido."
                    }
                },
                button_text1: "Pular vídeo",
                button_text2: "Vamos jogar"
            },
            betGameNew: {
                modal: "iniciando o enigma "
            },
            main: {
                category_info: "Tema: ",
                buy_hint_info: {
                    span1: "Comprar pista",
                    span2: "Custo: 500 pontos"
                },
                limit_hint_info: {
                    title: "Limite de Pistas!",
                    text: "Você excedeu o número de pistas."
                },
                surrender_info: {
                    span1: "Desistir ",
                    span2: "do enigma"
                },
                wrapper_hints: {
                    loaderMessage: "carregando nova pista",
                    hint_index: "PISTA "
                },
                answer_input: {
                    input: "Insira sua resposta aqui",
                    button: "Enviar"
                },
                surrenderModal: "Desistir do enigma ",
                modalOptionsData: {
                    modalSubtitle: "Você não poderá jogá-lo novamente",
                    titleBtnOk: "Desistir",
                    titleBtnCancel: "Voltar"
                }
            },
            extract: {
                banner_info: {
                    span1: "Resposta",
                    span2: "Seu tempo acabou",
                    span3: "Enigma incompleto",
                    span4: "Você não completou o enigma",
                    span5: "Você desistiu desse enigma",
                    span6: "correta"
                },
                value: {
                    span1: "Prêmio",
                    span2: "Pistas",
                    span3: "Tentativas",
                    span4: "Saldo",
                    span5: "Tempo após 5 minutos",
                    span6: "Segundos",
                },
                "nextEnigma": "avançar"
            },
            gameOver: {
                smallTitle: "Jogo concluido",
                title: "Gratidão",
                redirectText: [
                    "Agora preencha um feedback sobre o Game. Sua opinião é de extrema importância para continuarmos aprimorando nossa plataforma.",
                    "Obrigado por jogar o Repense Game. Esperamos que tenha curtido a experiência. :)"
                ]
            },
            finalScore: {
                option_button: "próximo enigma",
                visualFeedback: {
                    buttonNext: "Relatório",
                    title: "Pontuação final:",
                    completed: "Concluído"
                }
            },
            generateReport: {
                centeredLoader1: "Buscando seu relatório",
                centeredLoader2: "Erro ao gerar seu relatório",
                centeredLoader3: "Buscando seu relatório"
            },
            performance: {
                // falta esse
                headerTitle: "Performance",
                scenary: "Média de acertos",
                strong1: "global",
                pie_info_you: "você",
                mean_hits: "média de acertos:",
                minutes: "minutos até o acerto",
                hints_to_hit: "pistas</strong> até o acerto",
                attempts_to_hit: "tentativas</strong> até o acerto"
            },
            dashboard: {
                smallTitle: "Repense",
                title: "Concluído",
                desc: "Olá! Você já cumpriu essa etapa e não tem mais acesso ao game, mas você pode conferir o relatório",
                feedback: "ou nos deixar um feedback",
                textButton: "Ver relatório",
                textButton2: "Enviar feedback"
            },
            feedback: {
                experience: {
                    beforeBold: "Como foi a sua",
                    titleBold: "experiencia no game?",
                    experienceStatusDescription: [
                        "Excelente",
                        "Muito Boa",
                        "Regular",
                        "Ruim",
                        "Péssima"
                    ]
                },
                contactAuthorization: 'Autorizo que a Huddle entre em contato e me mantenha atualizade de futuras novidades',
                textButton: 'próximo',
                explain: {
                    beforeBold: "Curtiu a experiência? Deixe aqui seu feedback sobre o game que acabou de concluir, permitindo que a gente compreenda e compartilhe suas impressões.",
                    placeholder: "Digite aqui seu depoimento",
                    problemDesc: "Algo inesperado aconteceu durante o game? Entre em contato conosco clicando no botão abaixo."
                },
                finish: {
                    smallTitle: "Feedback Enviado",
                    title: "Feedback Enviado!",
                    descInfo:
                        "Sua opinião é de extrema importância para continuarmos aprimorando a plataforma",
                    textButton: "Concluir"
                },
                gift: {
                    beforeBold: "Que",
                    titleBold: "tal presentear algum RH",
                    afterBold:
                        "com créditos para utilizar a Huddle em seus processo seletivos?",
                    form_default: {
                        title: "insira os dados da(o) presenteada(o):"
                    },
                    options: [
                        "Não conheço ninguém que atua com RH para presentar :(",
                        "Quero presentear alguém que trabalha em um RH!"
                    ],
                    labels: ["Nome", "Empresa", "E-mail", "Telefone"]
                },
                preference: {
                    beforeBold:
                        "Você prefere modelos de avaliação em processo seletivo como esse",
                    titleBold: "game ou modelos tradicionais?",
                    options: [
                        "Prefiro modelos como esse que participei agora (games).",
                        "Prefiro modelos convencionais, como testes de lógica.",
                        "Prefiro modelos onde respondo sobre mim e obtenho meu perfil."
                    ]
                },
                problem: {
                    beforeBold: "",
                    titleBold: "",
                    afterBold: "",
                    options: [
                        "Dei comando na plataforma que não apareceram no game (pedir pistas, enviar respostas, etc).",
                        "Tive problemas em me comunicar com outros participantes.",
                        "Tive problemas com a minha conexão, ou com meu dispositivo e afins",
                        "Durante o jogo, tive problemas com os enigmas.",
                        "O game terminou antes do tempo demonstrado para mim."
                    ]
                }
            },
            report: {
                competences: {
                    componentsData: {
                        headerTitle: "perfil",
                        backTo: "Gráfico",
                        buttonNextTitle: "Finalizar",
                        accordionDataTitle: [
                            "Estruturada",
                            "Criativa",
                            "Arrojada",
                            "Conservadora",
                            "Pratica",
                            "Econômica",
                            "Veloz",
                            "Analítica",
                            "Flexivel",
                            "Persistente"
                        ],
                        accordionText: [
                            [
                                "Na hora de resolver um problema, é possível captar informações que demonstram que você dá preferência para uma abordagem mais estruturada, que evidencia traços de planejamento e que segue uma forma conectada com as suas ações anteriores para alcançar um objetivo final.",
                                "Na hora de resolver um problema, é possível captar informações que demonstram que você dá preferência a uma abordagem mais criativa, desestruturada, com grande variação entre suas ações e pouca conexão com o que fez anteriormente"
                            ],
                            [
                                "Ao enfrentar cenários de risco, é possível captar dados que evidenciam que você prefere uma abordagem de maior tolerância ao risco, se colocando-se em situações de exposição em que pode obter ganhos maiores, mesmo compreendendo que sua perda pode ser inversamente proporcional.",
                                "Ao enfrentar cenários de risco, é possível captar dados que evidenciam que você prefere uma abordagem mais cautelosa, buscando entender qual deve ser a forma ideal para tomar suas decisões e evitar prejuízos desnecessários."
                            ],
                            [
                                "Em relação à gestão dos recursos que tinha para alcançar o objetivo, é possível captar informações que demonstram que você priorizou alcançar o resultado em um tempo mais curto, utilizando-se de recursos melhores, mesmo que fossem mais \"caros\".",
                                "Em relação à gestão dos recursos que tinha para alcançar o objetivo, é possível captar informações que demonstrem que você priorizou a utilização de recursos mais \"baratos\", mesmo que isso levasse mais tempo para alcançar o resultado. "
                            ],
                            [
                                'Durante todo o teste, foi possível perceber que você priorizou alcançar o objetivo em um tempo mais curto, usando a velocidade a seu favor em uma abordagem similar à \"tentativa e erro\". ',
                                "Durante todo o teste, foi possível perceber que você procurou entender com profundidade o cenário em que estava inserido, no qual é observado um tempo maior entre cada ação ou tomada de decisão sua. "
                            ],
                            [
                                "Em cenários inexplorados ou quando erra algo, necessitando de mudanças de estratégia e uma reação rápida, foi percebido em você um bom nível de adaptação e reação.",
                                "Quando o resultado esperado não ocorria, você persistiu por bastante tempo, buscando utilizar os recursos que tinha, desistindo apenas quando acreditava que realmente não conseguiria."
                            ]
                        ]
                    }
                },
                performance: {
                    mean_info: {
                        span1: "Sua",
                        strong1: "média de acertos"
                    },
                    others_means: {
                        h3: {
                            strong1: "minutos ",
                            span1: "até o acerto"
                        }
                    },
                    pie_info_you: "você",
                    hints_to_hit: {
                        strong1: "pistas ",
                        span1: "até o acerto"
                    },
                    hints_info_you: "você",
                    attempts_to_hit: {
                        strong1: "tentativas ",
                        span1: "até o acerto"
                    },
                    attempts_info_you: "você",
                    componentsData: {
                        buttonNextTitle: "Meu perfil",
                        backText: "Competências"
                    },
                    chartOptions: {
                        labels: ["VOCÊ"]
                    }
                }
            }
        },
        components: {
            betAlert: {
                "desc-first-top": {
                    p1: "Você está investindo ",
                    p2:
                        " no enigma. Esse valor será subtraído do seu total de pontos. Em caso de sucesso no enigma, você receberá o dobro do mesmo valor."
                },
                "desc-first-bottom": {
                    span1: "Lembrando que o número de pontos utilizados ",
                    bold1: "não interfere na dificuldade dos enigmas ",
                    span2: "e você pode tentar ",
                    bold2: "valores diferentes ",
                    span3: "em cada um deles."
                },
                "desc-alert": {
                    span1: "Você está investindo"
                },
                "bet-alert-buttons": {
                    "button-container1": "Vamos lá!",
                    "button-container2": "Voltar"
                }
            },
            betIndex: {
                "index-step": "enigma "
            },
            betOption: {
                title: "Escolha o seu",
                subtitle: "investimento!",
                "desc-button": "Prêmio: ",
                "footer-desc":
                    "O número de pontos utilizados não interfere na dificuldade dos enigmas. Todos têm o mesmo nível de desafio."
            },
            header: {
                enigma_info_gunmetal: {
                    "enigma-step": "enigma ",
                    "premium-step": "valendo: "
                },
                enigma_attempts: "Tentativas livres",
                game_modal: "Preparando a próxima etapa"
            },
            navbar: {
                help_button: "ajuda"
            },            
            acceptance: {
                acceptance_checkbox: {
                    strong1: "Li e compreendo ",
                    span1: "os termos acima"
                },
                button: "próximo"
            },
            scenaryOptions: {
                scenery_options: "comparativo com a média global dos jogadores"
            },
            HeaderFeedback: {
                desc_progress: "completo"
            },
            Answer: {
                answer_button: "Responder",
                answer_input: "Insira sua resposta aqui"
            },
            HintsOptions: {
                buy_hint_info: {
                    span1: "Comprar pista",
                    span2: "Custo: 500 pontos"
                },
                surrender_info: {
                    span1: "Desistir ",
                    span2: "do enigma"
                }
            },
            ChartRadar: {
                labels: [
                    "Estruturada",
                    "Arrojada",
                    "Prática",
                    "Veloz",
                    "Flexível",
                    "Criativa",
                    "Conservadora",
                    "Econômica",
                    "Analítica",
                    "Persistente"
                ],
                datasets: {
                    label: "Você"
                }
            },
            ReportHedaer: {
                logout: "sair",
                swal: {
                    title: "Você está prestes a sair",
                    text: "Você deseja sair?"
                }
            }
        },
        containers: {
            FeedbackContainer: {
                textButton: "Vamos lá",
                smallTitle: "Gostaríamos de saber",
                title: "sua opinião",
                desc:
                    "Para nós, é muito importante saber o que você achou, assim conseguimos deixar a experiência cada vez melhor."
            }
        },
        store: {
            report_state: {
                title1: "Limite de responsabilidade",
                title2: "Elegibilidade",
                title3: "Metodologia",
                content1: [
                    "A Huddle não tem a intenção e nem o interesse de estabelecer um perfil psicológico ou comportamental permanente/definitivo das pessoas que passam pelo nosso método de Seleção por Performance. ",
                    "Assim sendo, compreendemos que cada indivíduo é muito complexo e deve ser analisado por diversas abordagens complementares à nossa ferramenta, como dinâmicas em grupo, painéis de apresentação e entrevistas por competência.",
                    "Enfatizamos que os insights gerados por meio das nossas ferramentas devem ser complementados por outros dados, não devendo ser a fonte exclusiva e sobrepondo conclusões geradas por outras abordagens de avaliação."
                ],
                content2: [
                    "A escolha dos participantes que seguirão nas etapas seguintes do processo seletivo é inteiramente realizada pelos avaliadores e recrutadores da organização.  ",
                    "Toda comunicação com as pessoas é de inteira responsabilidade da empresa contratante e nós não detemos a lista de aprovados e reprovados na própria etapa que conduzimos. Também não exercemos nenhum controle ou influência sobre esta decisão. ",
                    "Assim sendo, reiteramos que não emitimos nenhum informativo para as pessoas sobre sua continuidade, ou não, no processo seletivo."
                ],
                content3:
                    "Utilizamos como referência o estudo realizado pela TTI Success International™, que contempla 23 competências consideradas universais para as empresas. Filtramos e agrupamos essas competências, conectando-as com a realidade de um cargo de início de carreira e também com aquilo que é possível ser analisado durante o jogo."
            }
        }
    },
    "en-US": {
        views: {
            statementGame:{
                titles: ["Privacy Policy", "Terms of use", "ACCEPTANCE", "OBJECTIVE", "PLATFORM", "SCHEDULE OF SESSIONS AND SCHEDULES", "PASSWORDS AND SECURITY:", "RESPONSIBILITIES", "PRIVACY AND USE OF USER INFORMATION", "PROPERTY RIGHT", "GENERAL PROVISIONS"],
                paragraphs: ["All your personal information collected will be use to make your access to our platform more productive and enjoyable.", 
                "The personal information collected may include your name, email and phone number", 
                "",
                "Remember that the use of the platform implies acceptance of this privacy agreement.", 
                "Huddle staff reserves the right to change this agreement without notice. Therefore, we recommend that you check our privacy policy regularly so that you are always up to date.", 
                "The present term of acceptance of use (“Term”) of our platform (“Platform”) is signed between HUDDLE TECNOLOGIA EM RH LTDA. (“Huddle”), maintainer and sole holder of Repense Game, Quizz Game and Decode Game (“Games”), and the candidate (“Candidate”), which, fully adheres to the Term by clicking below on “Register” or in the acceptance box of the Term.", 
                "The Candidate may only use the Platform, if he fully agrees to comply with all the terms and conditions set out below, and the consent to this Term may be in the following ways:", 
                "Clicking on the Term acceptance box;", 
                "Performing the registration of personal data, which will be considered as unconditional acceptance of the proposed terms and conditions.", 
                "The CANDIDATE may clarify doubts about this Term by contacting Huddle directly, through our Facebook page",
                "or by email.", 
                "By agreeing to this Term, the Candidate shall have the right to use his/her access to the Platform to register, make appointments, participate in the selection process games, consult the rules and clarify doubts.", 
                "The rules that will be observed are set out in “Rules of the Game” and also available in",
                "this link.", 
                "Huddle undertakes to keep the Candidate's registration and access confidential data under the terms of the law, emphasizing that it will share the result information of the games with the human resources consultancy (“ ”) and / or with the company (“ Company ”) responsible /  for the selection process. ", 
                "Huddle will provide technical support to the Candidate for full use of the Platform, at times and forms standardized by Huddle itself and during game sessions according to the rules posted on the website.", 
                "The Candidate, for his part, recognizes that the information technology area is always in constant development, and that perfection and the absence of defects or risks are nonexistent in this sector.", 
                "It is the Candidate's sole responsibility and burden to provide the computer equipment and Internet connection necessary to access the Platform. Huddle is not responsible, under any circumstances, for the existence, operation and quality of such equipment, systems and connections.", 
                "The Applicant understands and agrees that Huddle may suspend or interrupt the operation of the Platform for maintenance purposes, either by chance, or force majeure, regardless of any prior notice.", 
                "The Platform may contain some models of Games, which assess the competences of the Candidates, and may consist of more than 1 stage of the game. The central objective of the referred Games is to solve the problematic situations proposed. In some cases, it will be necessary to schedule a session, according to the dates and times available.", 
                "The number of sessions, as well as the dates and times, will be determined by the Consultancy or by the Company responsible for the selection process.", 
                "Eventually, Huddle will be able to define the number of sessions, as well as the dates and times when they will run, based on the survey of the largest amounts of access, extracted from the history of matches already carried out.", 
                "It is possible to reschedule according to the available sessions, except in cases of last session. Therefore, we recommend that you make the game as soon as possible, to avoid any problems.", 
                "Under no circumstances will be possible to play the game without prior schedule.", 
                "The Candidate acknowledges that his password for accessing the site it is personal and non-transferable, as well as hi/her performance, and under no circumstances may he provide it to third parties, or have the game played by someone else and, consequently, have his/her performance obtained by another person, and must take all appropriate measures to guarantee its confidentiality.", 
                "The Candidate undertakes to respond fully for any legal consequences arising directly from the loss of password, due to his behavior considered willful or guilty (imprudence, negligence, malpractice).", 
                "The Platform is offered to, and accepted by, the Candidate, in the technical and perfect state it is in, which is why Huddle is not responsible for any other guarantees; not being responsible, among others, the following hypotheses:", 
                "the adequacy of the site to the Candidate's needs or expectations;", 
                "the results or performance expected by the Candidate when using the Platform;", 
                "for any information, summons or communication conveyed by the Companies and / or Consulting of the selection process;", 
                "The validity of the summons email is described in the body of the email. In cases where the deadline for scheduling is up to 10 minutes before the last available session.", 
                "for problems with connection, electricity, technical failure of components and things that are not in our control; and", 
                "due to problems during the realization of the game, even if they originated by Huddle, if not reported at the moment that occurred or within two hours after the end of the session.", 
                "Huddle is responsible only for the game, and has no influence on the schedule of the selection process, calls for other stages, information on approved, disapproval sent to Candidates, among others, which are the responsibility of the Consulting and / or Company of the selective process;", 
                "Both parties declare to be fully aware that the use of any computer system in an environment exposed to the internet is subject to attacks by third parties, neither party being liable to the opposing party, or third parties, for any damages caused by invasions in the website by hackers, or third parties with similar intentions.", 
                "Huddle reserves the right, once the Candidate's failure to comply with any obligation arising from this Term, or even if there is evidence of fraud in the Candidate's performance, delete his registration and notify the Company and / or Consulting of the process selective, without prejudice to the possibility of sending your registration data and access to the competent legal authorities, without prejudice to your privacy rights.", 
                "The Candidate undertakes not to share any game information with third parties, including printscreen, rules, answers, or any information that is considered confidential by Huddle's Performance Audit team.", 
                "The chat, in the Decode Game stage, is mandatory, and the use of other means of communication for solving group puzzles is not authorized. Failure to observe this clause directly impacts performance and may lead to the elimination of the Candidate's participation in the selection process.", 
                "The Candidate undertakes to inform Huddle's technical support of any evidence of fraud that he/she witnesses, or becomes aware of, in order to ensure the smoothness of the selection process.", 
                "Huddle reserves the right to eliminate the Candidate who does not comply with any of the aspects covered in this Term.", 
                "It is Huddle's policy to respect the privacy of its Candidates. Therefore, Huddle will not edit or reveal any information about the Candidate or about the Candidate's use of these services, without his/her permission, except for the purpose of this Term and in the event that such conduct is necessary to:", 
                "protect the interests of Huddle or third parties;", 
                "respond to any claim that violates the rights of third parties;", 
                "identify and solve technical problems;", 
                "comply with legal procedure, including judicial determination or any competent regulatory body;", 
                "enforce the terms of the services now provided.", 
                "We collect anonymous browsing information from users through authorized third-party systems, respecting all data security and privacy issues, in order to better understand our audience's profile or offer a better browsing experience. If you do not want anonymous browsing data to be used, access and change your browser's privacy settings.", 
                "Privacy of the cell phone: By registering your cell phone number, you are authorizing Huddle to send reminders of appointments and other contact needed that can be mapped throughout the process.", 
                "The Candidate is aware that, with his consent, from his/her registration and acceptance of the Term, messages may be sent to his/her e-mail regarding the scheduling and / or rescheduling of the session time.", 
                "The Candidate acknowledges that all content (written, spoken, image and sound) displayed on the Huddle platform is protected by the law that regulates trademarks, and others", 
                "The Candidate undertakes not to use such content without prior and express knowledge of Huddle, under penalty of being held civilly and criminally responsible for violations that commit the rights of others.", 
                "Huddle reserves the right to change the terms and conditions of this Term at any time, which will always be displayed to Candidates who access this document through the website.", 
                "",
                "I have read and understood",
                "the terms above"
            ],
                seeMoreLink: "see all",
                textButton: 'next'
            },
            rules: {
                "title-rules": {
                    title: "Remembering some",
                    regras: "rules"
                },
                "text-rules": {
                    p: "IMPORTANT!",
                    strong1: "We are not testing your knowledge! ",
                    span1: "Therefore, you can ",
                    strong2: "search",
                    span2: "to find the answers",
                    li1: {
                        span1: "You will start with",
                        strong1: "$40.000 ",
                        span2: "in your",
                        strong2: "current balance"
                    },
                    li2: {
                        span1: "The ",
                        strong1: "reward ",
                        span2: "will always be ",
                        strong2: "double ",
                        span3: "your ",
                        strong3: "bet"
                    },
                    li3: {
                        span1: "each ",
                        strong1: "hint ",
                        span2: "purchased will cost",
                        strong2: "$500"
                    },
                    li4: {
                        span1: "You have",
                        strong1: "3 free attempts",
                        span2: "and aftter will pay",
                        strong2: "$50 each attempt"
                    },
                    li5: {
                        span1: "You will have ",
                        strong1: "10 minutes ",
                        span2: "to finish ",
                        strong2: "each puzzle"
                    },
                    li6: {
                        span1: "After ",
                        strong1: "5 minutes ",
                        span2: "you ",
                        strong2: "will lose $1 each second"
                    }
                },
                button_text1: "skip video",
                button_text2: "let's play"
            },
            betGameNew: {
                modal: "starting puzzle "
            },
            main: {
                category_info: "Theme: ",
                buy_hint_info: {
                    span1: "Buy hint",
                    span2: "Cost: $500"
                },
                limit_hint_info: {
                    title: "Hint limit!",
                    text: "You exceeded the number of hints."
                },
                surrender_info: {
                    span1: "Give up ",
                    span2: "the puzzle"
                },
                wrapper_hints: {
                    loaderMessage: "loading knew hint",
                    hint_index: "HINT "
                },
                answer_input: {
                    input: "Insert your answer here",
                    button: "Send"
                },
                surrenderModal: "Give up the puzzle ",
                modalOptionsData: {
                    modalSubtitle: "You can't play again",
                    titleBtnOk: "Give up",
                    titleBtnCancel: "Go back"
                }
            },
            extract: {
                banner_info: {
                    span1: "Answer",
                    span2: "Time out",
                    span3: "Puzzle incomplete",
                    span4: "You did not complete the puzzle",
                    span5: "You gave up the puzzle",
                    span6: "correct"
                },
                value: {
                    span1: "Award",
                    span2: "Hints",
                    span3: "Attempts",
                    span4: "Final Balance",
                    span5: "Time after 5 minutes",
                    span6: "Seconds",
                },
                "nextEnigma": "advance"
            },
            gameOver: {
                smallTitle: "Game completed",
                title: "Thanks",
                redirectText: [
                    "Now fill in a feedback about the game. Your opinion is extremely important to continue improving our platform",
                    "Thank you for playing Repense Game. We hope you enjoyed the experience. :)"
                ]
            },
            finalScore: {
                option_button: "next puzzle",
                visualFeedback: {
                    buttonNext: "Report",
                    title: "Final balance:",
                    completed: "completed"
                }
            },
            generateReport: {
                centeredLoader1: "Searching your report",
                centeredLoader2: "Error to generate your report",
                centeredLoader3: "Searching your report"
            },
            performance: {
                // falta esse
                headerTitle: "Performance",
                scenary: "average of hit",
                strong1: "global",
                pie_info_you: "you",
                mean_hits: "average of hits",
                minutes: "minutes untill hit",
                hints_to_hit: "hints</strong> until hit",
                attempts_to_hit: "attempts</strong> until hit"
            },
            dashboard: {    
                smallTitle: "Repense",
                title: "Completed",
                desc: "Hi! You have already completed this step and no longer have access to the game, but you can check the report",
                feedback: "or leave us a feedback",
                textButton: "See report",
                textButton2: "Send feedback"
            },
            feedback: {
                experience: {
                    beforeBold: "How was your",
                    titleBold: "experience in the game?",
                    experienceStatusDescription: [
                        "Excellent",
                        "Very good",
                        "Regular",
                        "Bad",
                        "Horrible"
                    ]
                },
                contactAuthorization: 'I authorize Huddle to contact and keep me updated on future news',
                textButton: 'next',
                explain: {
                    beforeBold: "Did you enjoy the experience? Leave your feedback on the game you just completed here, allowing us to understand and share your impressions.",
                    placeholder: "Enter your testimonial here",
                    problemDesc: "Did something unexpected happen during the game? Please contact us by clicking on the button below."
                },
                
                finish: {
                    smallTitle: "Thanks",
                    title: "Feedback Sent",
                    descInfo:
                        "Thank you for playing Repense Game. We hope you enjoyed the experience. :)",
                    textButton: "Finish"
                },
                gift: {
                    beforeBold: "How about",
                    titleBold: "sending a gift to a HR",
                    afterBold:
                        "with credits to use in their selection process?",
                    form_default: {
                        title: "insert the gift recipient data:"
                    },
                    options: [
                        "I don't know anybody who works with HR to introduce :(",
                        "I want to send a gift to someone who works in an HR!"
                    ],
                    labels: ["Name", "Company", "E-mail", "Telephone"]
                },
                preference: {
                    beforeBold:
                        "Do you prefer evalution models like this one",
                    titleBold: "game or tradicional models?",
                    options: [
                        "I prefer models like this one I participed now (games).",
                        "I prefer convencional models, like logic tests.",
                        "I prefer models where I answer about me and receive my profile."
                    ]
                },
                problem: {
                    beforeBold: "",
                    titleBold: "",
                    afterBold: "",
                    options: [
                        "I gave command on the plataform that did not appear in the game (asked for hints, send anwers, etc)",
                        "I had problem to communicate with others participants",
                        " I had problem with my connection, or device and related",
                        "During the game, I had problems with puzzles.",
                        "The game finished before the time showed for me."
                    ]
                }
            },
            report: {
                competences: {
                    componentsData: {
                        headerTitle: "profile",
                        backTo: "Graphic",
                        buttonNextTitle: "Finish",
                        accordionDataTitle: [
                            "methodical",
                            "Creative",
                            "Bold",
                            "Cautious",
                            "Practical",
                            "Lean",
                            "Fast",
                            "Analytic",
                            "Flexible",
                            "Persistent"
                        ],
                        accordionText: [
                            [
                                "When it comes on solving a problem, it is possible to capture information that demonstrates that you prefer a more structured approach, that highlights planning traits and that follows a way connected with your previous actions to reach a final goal.",
                                "When it comes on solving a problem, it is possible to capture information that demonstrates that you prefer a more creative, unstructured approach, with many variations between your actions and little connection with what you did previously"
                            ],
                            [
                                "When exposed to risk scenarios, it is possible to capture data that shows that you prefer a more risk-tolerant approach, placing yourself in exposure situations where you can obtain greater gains, understanding that your loose may be inversely proportional.",
                                "When exposed to risk scenarios, it is possible to capture data that shows that you prefer a more cautious approach, seeking to understand what should be the ideal way to make your decisions and avoid unnecessary losses."
                            ],
                            [
                                "Regarding the management of the resources that you had to reach the goal, it is possible to capture information that shows that you prioritized to achieve the result in a shorter time, using better resources, even if they were more expensive",
                                "Regarding the management of the resources you had to achieve the objective, it is possible to capture information that demonstrates that you prioritized the use of cheaper resources even if it took more time to achieve the result."
                            ],
                            [
                                "Throughout the test it was possible to notice that you prioritized a shorter time to reach the goal, using speed in your advantage.",
                                "Throughout the test it was possible to notice that you tried to understand the scenario that you were inserted, where a longer time was observed between each action or decision you made. "
                            ],
                            [
                                "In different scenarios or when something went wrong, and you needed to change the strategies and have a aquick reaction, a good level of adaptation / reaction was noticed in you.",
                                "When expected result did not happen, you persisted for a long time, trying to use the resources you had and gave up only when you believed that you really couldn't."
                            ]
                        ]
                    }
                },
                performance: {
                    mean_info: {
                        span1: "your",
                        strong1: "average of hits"
                    },
                    others_means: {
                        h3: {
                            strong1: "minutes ",
                            span1: "untill hits"
                        }
                    },
                    pie_info_you: "you",
                    hints_to_hit: {
                        strong1: "clues ",
                        span1: "untill hits"
                    },
                    hints_info_you: "you",
                    attempts_to_hit: {
                        strong1: "attempts ",
                        span1: "untill hit"
                    },
                    attempts_info_you: "you",
                    componentsData: {
                        buttonNextTitle: "My profile",
                        backText: "Soft Skills"
                    },
                    chartOptions: {
                        labels: ["YOU"]
                    }
                },
                
            }
        },
        components: {
            betAlert: {
                "desc-first-top": {
                    p1: "Place yout bet",
                    p2:
                        " This value will be withdrawn from your current balance. If the puzzle is right, you will receive twice as much:"
                },
                "desc-first-bottom": {
                    span1: "Keep in mind that the bet",
                    bold1: "does not interfere with the complexity of the puzzles",
                    span2: "and you can set place",
                    bold2: "different bets",
                    span3: "at each round."
                },
                "desc-alert": {
                    span1: "You are betting"
                },
                "bet-alert-buttons": {
                    "button-container1": "Let's go!",
                    "button-container2": "Go back"
                }
            },
            betIndex: {
                "index-step": "puzzles "
            },
            betOption: {
                title: "Make your",
                subtitle: "bet!",
                "desc-button": "Award: ",
                "footer-desc":
                    "The amount bet does not interfere with the difficulty of the puzzles. All have the same level of challenge."
            },
            header: {
                enigma_info_gunmetal: {
                    "enigma-step": "puzzle ",
                    "premium-step": "award: "
                },
                enigma_attempts: "Free attempts",
                game_modal: "Preparing for the next step"
            },
            navbar: {
                help_button: "Help"
            },
            acceptance: {
                acceptance_checkbox: {
                    strong1: "I read and understood",
                    span1: "the above terms"
                },
                button: "next"
            },
            scenaryOptions: {
                scenery_options: "comparative with the global average of players"
            },
            HeaderFeedback: {
                desc_progress: "completed"
            },
            Answer: {
                answer_button: "Answer",
                answer_input: "Insert your answer here"
            },
            HintsOptions: {
                buy_hint_info: {
                    span1: "Buy clue",
                    span2: "Cost: $500"
                },
                surrender_info: {
                    span1: "Give up",
                    span2: "the puzzle"
                }
            },
            ChartRadar: {
                labels: [
                    "methodical",
                    "Creative",
                    "Bold",
                    "Cautious",
                    "Practical",
                    "Lean",
                    "Fast",
                    "Analytic",
                    "Flexible",
                    "Persistent"
                ],
                datasets: {
                    label: "You"
                }
            },
            ReportHedaer: {
                logout: "leave",
                swal: {
                    title: "You are abou to leave",
                    text: "Would you like to leave?"
                }
            }
        },
        containers: {
            FeedbackContainer: {
                textButton: "Let's go",
                smallTitle: "We want to know",
                title: "your opinion",
                desc:
                    "For us, it is very important to know what you think, so we can make the experience even better."

            }
        },
        store: {
            report_state: {
                title1: "Limitation of liability",
                title2: "Eligibility",
                title3: "Methodology",
                content1: [
                    "Huddle has no intention or interest in establishe a permanent / definitive psychological or behavioral profile of people who take our Selection Performance method. ",
                    "Therefore, we understand that each individual is very complex and must be analyzed by several complementary approaches then just our tool, such as group dynamics, presentation panels and interviews. ",
                    "We emphasize that the insights generated through our tools must be complemented by other data, and should not be the exclusive source and overlappe conclusions generated by other assessment. "

                ],
                content2: [
                    "The choice of the participants who will follow in the next stages of the selection process is entirely made by the evaluators and recruiters of the organization.",
                    "All communication with the candidates is the responsibility of the contracting company and we do not have the list of approved and disapproved at the stage we conduct. We also have no control or influence over this decision. ",
                    "Therefore,  we reiterate that we did not issue any information to candidates about their continuity, or not, in the selection process. ",
                ],
                content3:
                    "We used as a reference, the study carried out by TTI Success International ™, which contemplates 23 skills considered universal for companies. We filtered and grouped those skills, connecting them with the reality of an early career position and also with what can be analyzed during the game. "
            }
        }
    },
    "es": {
        views: {
            statementGame: {
                titles: ["Política de privacidad", "Términos de uso", "De la aceptación", "Del objetivo", "De la platamforma", "DE LOS HORARIOS DE LA SESIONES Y AGENDAMIENTOS", "CLAVES Y SEGURIDAD:", "DE LAS RESPONSABILIDADES", "DE LA PRIVACIDAD Y DEL USO DE INFORMACIONES DEL USUARIO", "DERECHO DE PROPIEDAD", "DISPOSICIONES GENERALES", "DEL FORO:",],
                paragraphs: [
                    "Todas sus informaciones personales recogidas serán utilizadas para tornar su ingreso a nuestra plataforma más productivo y agradable.",
                    "La garantía de confidencialidad de los datos personales de los usuarios de nuestra plataforma es importante para Huddle, por eso, todas las informaciones personales serán tratadas en acuerdo a la Ley General de Protección de Datos Personales del 14 de agosto de 2018 (Ley n.º 13.709/2018).",
                    "Las informaciones personales recogidas pueden incluir su nombre, e-mail, número de teléfono y CPF.",
                    "Se recuerda que el uso de la plataforma ya presupone la aceptación de este acuerdo de privacidad.",
                    "El equipo de Huddle se reserva el derecho de modificar este acuerdo sin previo aviso. De este modo, recomendamos que consulte nuestra política de privacidad con regularidad de manera a estar siempre actualizado.",
                    'El presente término de aceptación de uso ("Término") de nuestra plataforma (“Plataforma”) es celebrado entre HUDDLE TECNOLOGIA EM RH LTDA. (“Huddle”), inscrita en CNPJ/MF bajo el numero 19.653.495/0001-86, mantenedora y única titular de Repense Game, Cripto Game y Decode Game (“Games”), y el candidato(a) (“Persona”), que, adhiere integralmente al Término haciendo clic abajo en “Registrarse” o en el cuadro de aceptación del Término.',
                    "La persona solamente podrá utilizar la Plataforma, caso esté integralmente de acuerdo en cumplir con todos los términos y condiciones abajo establecidos, siendo que el consentimiento al presente Término se podrá otorgar de las siguientes maneras:",
                    "Haciendo clic en la caja de aceptación del Término;",
                    "Realizando el registro de los datos personales, que será considerado como aceptación incondicional de los términos y condiciones ya propuestos.",
                    "La PERSONA podrá aclarar dudas con respecto al presente Término al entrar en contacto directo con Huddle, a través de nuestra pagina en facebook",
                    "o por e-mail",
                    'Al estar de acuerdo con el presente Término, la Persona pasa a tener el derecho de utilizar su acceso a la Plataforma para realizar su registro, agendamientos, participar de los games de los procesos selectivos, consultar las reglas y aclarar dudas.',
                    'Las reglas que serán observadas están dispuestas en "Reglas del Juego" y también disponilizadas',
                    "en este enlace",
                    "Huddle se compromete a mantener los datos registrados y de acceso de la Persona de forma confidencial en los términos de la ley, destacando que compartirá las informaciones de resultado de los games con la consultoría de recursos humanos (“Consultoría”) y/o con la empresa (“Empresa”) responsables/responsable por el proceso selectivo.",
                    "Huddle brindará soporte tecnico a la Persona para una plena utilización de la Plataforma, en los horarios y formas padronizadas por la propia Huddle y durante las sesiones de los games según las reglas divulgadas en el sitio.",
                    "La Persona, por su lado, reconoce que el area de tecnología de la información está en constante desarrollo, y que la perfección y ausencia de defectos o riesgos no existen en ese sector.",
                    "Es de exclusiva responsabilidad y carga de la Persona proporcionar los equipajes informáticos y de conexión a Internet necesarios para el acceso a la Plataforma. Huddle no se hace responsable, de ninguna manera, por la existencia, funcionamiento y calidad de tales equipajes, sistemas y conexión.",
                    "La Persona entiende y está de acuerdo que Huddle podrá suspender o interrumpir el funcionamiento de la Plataforma para fines de mantenimiento, o por caso inesperado, o de fuerza mayor, independiente de cualquier previo aviso.",
                    "La Plataforma puede contener algunos modelos de Games, que evalúan las competencias de la Persona, pueden estar compuestos por más de 1 etapa de juego. El objetivo central de dichos Games es solucionar las situaciones problematicas propuestas. En algunos casos, para participar será necesario realizar el agendamiento en una sesión, de acuerdo a las fechas y horarios disponibles.",
                    "La cantidad de sesiones, bien como las fechas y horarios, serán determinados por la Consultoría o por la Empresa responsable por el proceso selectivo.",
                    "Eventualmente, Huddle podrá definir la cantidad de sesiones, así como las fechas y horarios en que éstas sucederán, teniendo como base el levante de las mayores cantidades de acceso, obtenidos del histórico de partidos ya realizados.",
                    "Es posible realizar un otro agendamiento de a acuerdo a las sesiones disponibles, excepto en casos de última sesión. De esta manera, se recomiendo que realice el game lo antes posible, para evitar eventuales problemas.",
                    "De niguna manera será posible realizar el game sin el previo agendamiento.",
                    "La Persona reconoce que su clave de acceso al sitio es de uso personal e intransferible, así como su desempeño, no siendo permitido, de ninguna manera, pasarla a terceros, o tener el game jugado por otra persona y, en consecuencia, tener su desempeño obtenido por otra persona, debiendo tomar las medidas apropiadas para garantizar su confidencialidad.",
                    "La Persona se compromete a responder integralmente por cualquier consecuencia juridica derivada directamente de la pérdida o extravío de su clave, en consecuencia a un comportamiento suyo considerado intencional o negligente (imprudencia, negligencia imperícia).",
                    "La Plataforma es ofrecida a la Persona, y es por éste aceptado, en estado tecnico y de perfección en que se encuentra, razón por la cual Huddle no responde por ninguna otra garantia; no responsabilizándose, entre otras, las seguintes hipótesis:",
                    "por la adecuación del sitio a las necesidades o expectativas de la Persona;",
                    "por los resultados o desempeño esperados por la Persona al utilizar la Plataforma;",
                    "por cualquier información, convocación o comunicación transmitida por la Empresa y/o Consultoría del proceso selectivo;",
                    "La validez del mensaje electronico de convocación está descrito en el cuerpo del e-mail. En casos en que no esté, el plazo límite de agendamiento es de hasta 10 minutos antes de la última sesión disponible.",
                    "por problemas con conexión, energía eléctrica, falla tecnica de componentes y similares que no están bajo nuestro control; y",
                    "por problemas durante a realización del game, aunque originados por Huddle, no relatados en el momento que ocurrieron o en hasta dos horas después del final de la sesión.",
                    "Huddle es responsable apenas por el game, y no posee influencia sobre el cronograma del proceso selectivo, convocaciones para otras etapas, informaciones de aprobados, envíos de reprobación a las Personas, entre otros, que son de responsabilidad de la Consultoría y/o Empresa del proceso selectivo.",
                    "Ambas las partes declaran tener pleno conocimiento de que el uso de qualquier sistema informático en ambiente expuesto a internet está sujeto a ataques de terceros, no responsabilizándose a ninguna de las partes ante la parte contraria, o terceros, por cualquier daño causado por invasiones al sitio por hackers, o terceros con intensiones similares.",
                    "Huddle se reserva el derecho de, una vez comprobado el incumplimiento por la Persona de cualquier obligación derivada del presente Término, o incluso si hay evidencia de fraude en el desempeño de la Persona, excluir su registro y notificar la Empresa y/o Consultoría del proceso selectivo, sin perjuicio de la posibilidad de envío de sus datos de registro y de acceso a las autoridades legales competentes, sin que eso represente daño a sus derechos de privacidad.",
                    "La Persona se compromete a no compartir cualquier información del game con terceros, incluyendo printscreen, redacciones de enigmas, respuestas, o cualquier información que sea entendida como confidencial por el equipo de Auditoría de Desempeño de Huddle.",
                    "El chat, en la etapa de Team Game, es de uso obligatório, no siendo autorizada la utilización de otros medios de comunicación para la resolución de los enigmas en grupo. El incumplimiento de esta cláusula impacta directamente en el desempeño y puede ocasionar la eliminación de la participación de la Persona en el proceso de selección.",
                    "La Persona se compromete a informar al soporte técnico de Huddle sobre cualquier prueba de fraude de la que sea testigo o de la que tenga conocimiento, a fin de garantizar la dignidad del proceso de selección.",
                    "Huddle se reserva el derecho que eliminar a la Persona que no cumpla cualquiera de los aspectos tratados en este Término.",
                    "Es política de Huddle respetar la privacidad de las Personas. De este modo, Huddle no editará o revelará ninguna información de la Persona o sobre la utilización de estos servicios por la Persona, sin su autorización, excepto para los fines de este Término y en el caso de que dicha conducta sea necesaria para:",
                    "proteger los intereses de Huddle o de terceros;",
                    "responder a eventual reclamo de que tal contenido viole derechos de terceros;",
                    "identificar y solucionar problemas técnicos;",
                    "cumplir con el procedimiento legal, incluso orden judicial o de cualquier organismo regulador competente;",
                    "hacer cumplir los términos de los servicios prestados.",
                    "Recopilamos informaciones anónimas de navegación de los usuarios a través de sistemas de terceros autorizados, respetadas todas las cuestiones de seguridad y privacidad de datos, con el fin de conocer mejor el perfil de nuestra audiencia u ofrecer una mejor experiencia de navegación. Si no desea que se utilicen datos de navegación anónimos, acceda y cambie la configuración de privacidad de su navegador.",
                    "Privacidad del celular: Al registrar su número de teléfono celular, autoriza a Huddle a enviar recordatorios de citas y otras necesidades de contacto que se pueden mapear durante todo el proceso.",
                    "La Persona es consciente de que, con su consentimiento, a partir de su registro y aceptación del Término, se le podrán enviar mensajes a su correo electrónico sobre la programación y/o reprogramación del horario de la sesión.",
                    "La Persona reconoce que todo el contenido (escrito, hablado, imagen y sonido) que se muestra en la plataforma Huddle está protegido por la ley que regula las marcas, patentes y demás derechos de propiedad industrial.",
                    "La Persona se compormete a no utilizar dicho contenido sin el conocimiento previo y expreso de Huddle, bajo la pena de ser considerado responsable civil e criminalmente por violaciones cometidas contra los derechos de los demás.",
                    "Huddle se reserva el derecho de cambiar a cualquier tiempo los términos y condiciones de este Término, que será siempre presentado a las Personas que accedan a este documento a través del sitio.",
                    "Las partes eligen al Tribunal de Distrito de la Capital del Estado de São Paulo como competente para dirimir eventuales conflictos derivados del presente acuerdo.",
                    "Leí y entendí",
                    "los términos antes citados"
                ],
                seeMoreLink: "ver todo",
                textButton: "siguiente"
            },
            rules: {
                "title-rules": {
                    title: "Recordando algunas",
                    regras: "reglas"
                },
                "text-rules": {
                    p: "¡IMPORTANTE!",
                    strong1: "¡No estamos probando conocimiento !",
                    span1: "Por eso, podrá ",
                    strong2: "investigar a gusto ",
                    span2: "para encontrar las respuestas",
                    li1: {
                        span1: "Empezará con ",
                        strong1: "$40.000 ",
                        span2: "en su ",
                        strong2: "cuenta corriente"
                    },
                    li2: {
                        span1: "El",
                        strong1: "premio ",
                        span2: "siempre será el ",
                        strong2: "doble ",
                        span3: "de su ",
                        strong3: "apuesta"
                    },
                    li3: {
                        span1: "Cada ",
                        strong1: "pista ",
                        span2: "comprada costará ",
                        strong2: "$500"
                    },
                    li4: {
                        span1: "Tiene ",
                        strong1: "3 intentos gratis ",
                        span2: "y después pagará ",
                        strong2: "$50 por intento"
                    },
                    li5: {
                        span1: "Tendrá ",
                        strong1: "10 minutos ",
                        span2: "para concluir ",
                        strong2: "cada enigma"
                    },
                    li6: {
                        span1: "Después de ",
                        strong1: "5 minutos ",
                        span2: "usted",
                        strong2: "perderá $1 a cada segundo"
                    }
                },
                button_text1: "saltar video",
                button_text2: "vamos a jugar"
            },
            betGameNew: {
                modal: "iniciando el enigma "
            },
            main: {
                category_info: "Tema: ",
                buy_hint_info: {
                    span1: "Comprar pista",
                    span2: "Costo: $500"
                },
                limit_hint_info: {
                    title: "Límite de Pistas!",
                    text: "Excediste el número de pistas."
                },
                surrender_info: {
                    span1: "Desistir ",
                    span2: "del enigma"
                },
                wrapper_hints: {
                    loaderMessage: "cargando nueva pista",
                    hint_index: "PISTA "
                },
                answer_input: {
                    input: "Ingrese su respuesta aquí",
                    button: "Enviar"
                },
                surrenderModal: "Desistir del enigma ",
                modalOptionsData: {
                    modalSubtitle: "No podrá jugarlo nuevamente",
                    titleBtnOk: "Desistir",
                    titleBtnCancel: "Volver"
                }
            },
            extract: {
                banner_info: {
                    span1: "Respuesta",
                    span2: "Su tiempo ha terminado",
                    span3: "Enigma incompleto",
                    span4: "No ha completado el enigma",
                    span5: "Usted ha desistido de ese enigma",
                    span6: "correcta"
                },
                value: {
                    span1: "Premio",
                    span2: "Pistas",
                    span3: "Intentos",
                    span4: "Saldo",
                    span5: "Tiempo después de 5 minutos",
                    span6: "Segundos",
                },
                "nextEnigma": "avanzar"
            },
            gameOver: {
                smallTitle: "Juego concluido",
                title: "Gratitud",
                redirectText: [
                    "Ahora escriba un cometario sobre el Game. Su opinión es de extrema importancia para seguir mejorando nuestra plataforma.",
                    "Gracias por jugar Repense Game. Esperamos que haya disfrutado la experiencia. :)"
                ]
            },
            finalScore: {
                option_button: "proximo enigma",
                visualFeedback: {
                    buttonNext: "Informe",
                    title: "Saldo final:",
                    completed: "Concluido"
                }
            },
            generateReport: {
                centeredLoader1: "Buscando su informe",
                centeredLoader2: "Error al generar su informe",
                centeredLoader3: "Buscando su informe"
            },
            performance: {
                // falta ese
                headerTitle: "Desempeño",
                scenary: "Promedio de aciertos",
                strong1: "global",
                pie_info_you: "usted",
                mean_hits: "promedio de aciertos:",
                minutes: "minutos hasta el acierto",
                hints_to_hit: "pistas</strong> hasta el acierto",
                attempts_to_hit: "intentos</strong> hasta el acierto"
            },
            dashboard: {
                smallTitle: "Repensar",
                title: "Concluido",
                desc: "¡Hola! Usted ya ha cumplido esa etapa y no tiene más acceso al game, pero puede revisar el informe",
                feedback: "o dejarnos un cometario",
                textButton: "Ver informe",
                textButton2: "Enviar comentario"
            },
            feedback: {
                experience: {
                    beforeBold: "¿Cómo fue su",
                    titleBold: "experiencia en el game?",
                    experienceStatusDescription: [
                        "Excelente",
                        "Muy buena",
                        "Regular",
                        "Mala",
                        "Péssima"
                    ]
                },
                contactAuthorization: 'Autorizo a que Huddle entre en contacto y me mantenga actualizado(a) sobre futuras novedades',
                textButton: 'siguiente',
                explain: {
                    beforeBold: "¿Le gustó la experiencia? Deje aquí su comentario sobre el game que acaba de concluir, permitiéndonos comprender y compartir sus impresiones.",
                    placeholder: "Digite aquí su comentario",
                    problemDesc: "Algo inesperado sucedió durante el game? Entre en contacto con nosotros haciendo clic en el botón abajo."
                },
                finish: {
                    smallTitle: "Comentario Enviado",
                    title: "¡Comentario Enviado!",
                    descInfo:
                        "Su opinión es de extrema importancia para seguir mejorando la plataforma",
                    textButton: "Terminar"
                },
                gift: {
                    beforeBold: "¿Qué",
                    titleBold: "tal dar de regalo a algún RRHH",
                    afterBold:
                        "créditos para utilizar a Huddle en sus procesos selectivos?",
                    form_default: {
                        title: "Ingrese los datos del destinatario:"
                    },
                    options: [
                        "No conozco a nadie que actúa con RRHH para regalar :(",
                        "Quero regalar a alguien que trabaja en un RRHH!"
                    ],
                    labels: ["Nombre", "Empresa", "E-mail", "Teléfono"]
                },
                preference: {
                    beforeBold:
                        "¿Prefiere modelos de evaluación en proceso selectivo como ese",
                    titleBold: "game o modelos tradicionales?",
                    options: [
                        "Prefiero modelos como ese que participé ahora (games).",
                        "Prefiero modelos convencionales, como pruebas de lógica.",
                        "Prefiero modelos donde respondo sobre mí y obtengo mi perfil."
                    ]
                },
                problem: {
                    beforeBold: "",
                    titleBold: "",
                    afterBold: "",
                    options: [
                        "Dí comandos en la plataforma que no aparecieron en el game (pedir pistas, enviar respuestas, etc.).",
                        "Tuve problemas en comunicarme con otros participantes.",
                        "Tuve problemas con mi conexión, o con mi dispositivo y similares",
                        "Durante el juego tuve problemas con los enigmas.",
                        "El juego terminó antes del tiempo que me fue demostrado."
                    ]
                }
            },
            report: {
                competences: {
                    componentsData: {
                        headerTitle: "perfil",
                        backTo: "Gráfico",
                        buttonNextTitle: "Finalizar",
                        accordionDataTitle: [
                            "Estructurado",
                            "Creativo",
                            "Audaz",
                            "Conservador",
                            "Práctico",
                            "Económico",
                            "Rápido",
                            "Analítico",
                            "Flexible",
                            "Persistente"
                        ],
                        accordionText: [
                            [
                                "Al momento de resolver un problema, es posible capturar informaciones que demuestran que usted da prioridad a un enfoque más estructurado, que muestra rastros de planificación y que sigue una forma conectada con sus acciones anteriores para alcanzar un objetivo final.",
                                "Al momento de resolver un problema, es posible capturar informaciones que demuestran que usted da prioridad a un enfoque más creativo, desestructurada, con amplia variación entre sus acciones y poca conexión con lo que ha hecho anteriormente"
                            ],
                            [
                                "Al exponerse a escenarios de riesgo, es posible capturar datos que muestran que usted prefiere un enfoque de mayor tolerancia al riesgo, colocándose en situaciones de exposición donde puede obtener mayores ganancias, aunque entiende que su pérdida puede ser inversamente proporcional.",
                                "Al exponerse a escenarios de riesgo, es posible capturar datos que muestran que usted prefiere un enfoque más cauteloso, buscando comprender cuál debe ser la forma ideal de tomar sus decisiones y evitar pérdidas innecesarias."
                            ],
                            [
                                'En cuanto a la gestión de los recursos que tenía para lograr el objetivo, es posible capturar información que demuestra que usted priorizó lograr el resultado en un menor tiempo, utilizando mejores recursos, aunque fueran más "caros"',
                                "En cuanto a la gestión de los recursos que tenía para lograr el objetivo, es posible capturar información que demuestra que usted priorizó utilizarse de recursos más “baratos” aunque le costara más tiempo para alcanzar el resultado."
                            ],
                            [
                                'A lo largo de la prueba fue posible notar que usted priorizó alcanzar la meta en un tiempo más corto, usando la velocidad a su favor en un enfoque similar al de "ensayo y error". ',
                                "A lo largo de la prueba fue posible notar que usted trató de entender a fondo el escenario en que estaba involucrado, en donde es observado un mayor tiempo entre cada acción o toma de decisión suya. "
                            ],
                            [
                                "En escenarios inexplorados o cuando se comete un error, requiriendo cambios de estrategia y una reacción rápida, se percibió en usted un buen nivel de adaptación/reacción.",
                                "Cuando el resultado esperado no sucedió, usted persistió durante mucho tiempo, tratando de usar los recursos que tenía y dándose por vencido sólo cuando creía que realmente no lograría."
                            ]
                        ]
                    }
                },
                performance: {
                    mean_info: {
                        span1: "Su",
                        strong1: "promedio de aciertos"
                    },
                    others_means: {
                        h3: {
                            strong1: "minutos ",
                            span1: "hasta el acierto"
                        }
                    },
                    pie_info_you: "usted",
                    hints_to_hit: {
                        strong1: "pistas ",
                        span1: "hasta el acierto"
                    },
                    hints_info_you: "usted",
                    attempts_to_hit: {
                        strong1: "intentos ",
                        span1: "hasta el acierto"
                    },
                    attempts_info_you: "usted",
                    componentsData: {
                        buttonNextTitle: "Mi perfil",
                        backText: "Competencias"
                    },
                    chartOptions: {
                        labels: ["USTED"]
                    }
                }
            }
        },
        components: {
            betAlert: {
                "desc-first-top": {
                    p1: "Usted está apostando ",
                    p2:
                        "Ese valor será debitado de su cuenta corriente. En caso de éxito en el enigma, usted recibirá el doble:"
                },
                "desc-first-bottom": {
                    span1: "Recordando que el valor de la apuesta ",
                    bold1: "no afecta la dificultad de los enigmas ",
                    span2: "y usted puede apostar ",
                    bold2: "valores diferentes ",
                    span3: "en cada uno de ellos."
                },
                "desc-alert": {
                    span1: "Usted está apostando"
                },
                "bet-alert-buttons": {
                    "button-container1": "¡Vamos!",
                    "button-container2": "Volver"
                }
            },
            betIndex: {
                "index-step": "enigma "
            },
            betOption: {
                title: "¡Haga su",
                subtitle: "apuesta!",
                "desc-button": "Premio: ",
                "footer-desc":
                    "El valor de la apuesta no afecta la dificultad de los dos enigmas. Todos tienen el mismo nivel de desafio."
            },
            header: {
                enigma_info_gunmetal: {
                    "enigma-step": "enigma ",
                    "premium-step": "valiendo: "
                },
                enigma_attempts: "Intentos gratis",
                game_modal: "Preparando la etapa siguiente"
            },
            navbar: {
                help_button: "ayuda"
            },
            acceptance: {
                acceptance_checkbox: {
                    strong1: "Leí y entendí ",
                    span1: "los términos antes citados"
                },
                button: "siguiente"
            },
            scenaryOptions: {
                scenery_options: "comparativo con el promedio global de los jugadores"
            },
            HeaderFeedback: {
                desc_progress: "completo"
            },
            Answer: {
                answer_button: "Responder",
                answer_input: "Ingrese su respuesta aquí"
            },
            HintsOptions: {
                buy_hint_info: {
                    span1: "Comprar pista",
                    span2: "Costo: $500"
                },
                surrender_info: {
                    span1: "Desistir ",
                    span2: "del enigma"
                }
            },
            ChartRadar: {
                labels: [
                    "Estructurado",
                    "Audaz",
                    "Práctico",
                    "Rápido",
                    "Flexible",
                    "Creativo",
                    "Conservador",
                    "Económico",
                    "Analítico",
                    "Persistente"
                ],
                datasets: {
                    label: "Usted"
                }
            },
            ReportHedaer: {
                logout: "salir",
                swal: {
                    title: "Usted está a punto de salir",
                    text: "¿Desea salir?"
                }
            }
        },
        containers: {
            FeedbackContainer: {
                textButton: "Vamos",
                smallTitle: "Nos gustaría saber",
                title: "su opinión",
                desc:
                    "Para nosotros, es muy importante saber lo que piensa, para que podamos hacer que la experiencia sea aún mejor."
            }
        },
        store: {
            report_state: {
                title1: "Límite de responsabilidad",
                title2: "Elegibilidad",
                title3: "Metodología",
                content1: [
                    "Huddle no tiene la intención ni interés en establecer un perfil psicológico o conductual permanente/definitivo de las personas que pasam por nuestro metodo de Selección por Desempeño. ",
                    "De esta manera, entendemos que cada individuo es muy complejo y debe ser analizado por varios enfoques complementarios a nuestra herramienta, como dinámicas de grupo, paneles de presentación y entrevistas por competencias.",
                    "Enfatizamos que los insights generados a través de nuestras herramientas deben complementarse con otros datos y no deben ser la única fuente y superponer las conclusiones generadas por otros enfoques de evaluación."
                ],
                content2: [
                    "La elección de los participantes que seguirán en las siguientes etapas del proceso de selección es realizada en su totalidad por los evaluadores y reclutadores de la organización.  ",
                    "Toda comunicación con las personas es responsabilidad exclusiva de la empresa contratante y no mantenemos la lista de aprobados y desaprobados en la misma etapa que conducimos. Tampoco ejercemos ningún control o influencia sobre esta decisión. ",
                    "De esta manera, reiteramos que no emitimos información alguna a las personas sobre su continuidad, o no, en el proceso de selección."
                ],
                content3:
                    "Utilizamos como referencia el estudio realizado por TTI Success International™, que incluye 23 habilidades consideradas universales para las empresas. Filtramos y reunimos estas competencias, conectándolas con la realidad de un puesto al inicio de su carrera y también con lo que se puede analizar durante el juego."
            }
        }
    }
};

const i18n = new VueI18n({
    locale: "pt-BR", // set locale
    fallbackLocale: "pt-BR", // set fallback locale
    messages: languages // set locale messages
});

export default i18n;